import FullScreenEventModalV2 from "./FullScreenEventModalV2";
export default FullScreenEventModalV2;
